interface ITargetName {
    body: string;
    head: string;
}

const AppendNodeElem = (elemntType: string, content: string, targetName: string) => {
    const Is_Link = content.split(/\r\n|\r|\n/).length <= 1  &&  content.indexOf("//") > -1 && content.indexOf(" ") <= -1;
    let x: any = null;
    if(Is_Link){
        if (elemntType === 'script') {
            x = document.createElement('script');
            x.src = content;
            x.type = 'text/javascript';
        } else if (elemntType === 'style') {
            x = document.createElement('link');
            x.href = content;
            x.type='text/css';
            x.rel = 'stylesheet';
        }
    } else {
        x = document.createElement(elemntType);
        if (elemntType === 'script') {
            // x.type = 'text/javascript';
            x.innerHTML = content;
        } else if (elemntType === 'style') {
            // x.type = 'text/css';
            x.appendChild(document.createTextNode(content));
        }
    }
    //append in head
    if (x) {
        (document[targetName as keyof ITargetName] || document.getElementsByTagName(targetName)[0]).appendChild(x);
    }
};

export default AppendNodeElem;
